
/* styles */
require("!!../../../node_modules/_extract-text-webpack-plugin@2.1.2@extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../node_modules/_vue-loader@11.3.4@vue-loader/lib/style-compiler/index?{\"id\":\"data-v-8fa16454\",\"scoped\":true,\"hasInlineConfig\":true}!../../../node_modules/_vue-loader@11.3.4@vue-loader/lib/selector?type=styles&index=0!./register_index.vue")

var Component = require("!../../../node_modules/_vue-loader@11.3.4@vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/_vue-loader@11.3.4@vue-loader/lib/selector?type=script&index=0!./register_index.vue"),
  /* template */
  require("!!../../../node_modules/_vue-loader@11.3.4@vue-loader/lib/template-compiler/index?{\"id\":\"data-v-8fa16454\"}!../../../node_modules/_vue-loader@11.3.4@vue-loader/lib/selector?type=template&index=0!./register_index.vue"),
  /* scopeId */
  "data-v-8fa16454",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/loginGroup/register_index.vue
// module id = 1208
// module chunks = 1